type ITeamLike = { id?: number };
type IRoleWithTeams = { teams?: ITeamLike[] };

type IAssignableUser = {
  teams?: ITeamLike[];
  teamIds?: number[];
  roles?: IRoleWithTeams[];
};

const isProgramAssistantAssignedToTeam = (user: unknown, teamId: number | string): boolean => {
  const teamIdNumber = Number(teamId);
  const assignableUser = user as IAssignableUser;

  if (assignableUser?.teams?.some(team => team?.id === teamIdNumber)) {
    return true;
  }

  if (assignableUser?.teamIds?.some(id => Number(id) === teamIdNumber)) {
    return true;
  }

  return (
    assignableUser?.roles?.some(role => role?.teams?.some(team => team?.id === teamIdNumber)) ??
    false
  );
};

export default isProgramAssistantAssignedToTeam;
